import React from 'react';
import { Alert, Button, Stack, Typography } from '@mui/material';
import { getAuthUrl } from '../../utils/subdomainUtils';
import {
  buildTrainingGeoAlertReturnPath,
  saveTrainingGeoAlertGuestIntent,
  type TrainingGeoAlertGuestIntent,
} from '../../../shared/trainingGeoAlertGuestIntent';

export type TrainingGeoAlertAuthWallProps = {
  intent?: TrainingGeoAlertGuestIntent;
  title?: string;
  body?: string;
  compact?: boolean;
};

function redirectToAuth(
  path: '/login' | '/register',
  intent?: TrainingGeoAlertGuestIntent,
): void {
  if (intent) {
    saveTrainingGeoAlertGuestIntent(intent);
  }
  const redirectUrl =
    typeof window !== 'undefined'
      ? buildTrainingGeoAlertReturnPath(
          window.location.pathname,
          window.location.search,
          window.location.hash,
        )
      : '/events';
  window.location.href = getAuthUrl(path, {
    includeRedirect: true,
    redirectUrl,
  });
}

export default function TrainingGeoAlertAuthWall({
  intent,
  title = 'Get training alerts by email',
  body = 'Create a free account or sign in to get emailed when new training is posted in your chosen areas.',
  compact = false,
}: TrainingGeoAlertAuthWallProps) {
  return (
    <Alert severity="info" role="status" data-testid="training-geo-alert-auth-wall">
      <Typography variant={compact ? 'body2' : 'subtitle2'} fontWeight={600} gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
        {body}
      </Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
        <Button
          variant="contained"
          size="small"
          onClick={() => redirectToAuth('/register', intent)}
          data-testid="training-geo-alert-create-account"
        >
          Create account
        </Button>
        <Button
          variant="outlined"
          size="small"
          onClick={() => redirectToAuth('/login', intent)}
          data-testid="training-geo-alert-sign-in"
        >
          Sign in
        </Button>
      </Stack>
    </Alert>
  );
}
